import { IAddOn } from '../types';

export function getTotalAddOnsPrice(addOns: IAddOn[]) {
    return addOns.reduce((acc, current) => acc + current.priceInt, 0);
}
